import { render, staticRenderFns } from "./ProxyDetect.vue?vue&type=template&id=b967ffc4&scoped=true"
import script from "./ProxyDetect.vue?vue&type=script&lang=js"
export * from "./ProxyDetect.vue?vue&type=script&lang=js"
import style0 from "./ProxyDetect.vue?vue&type=style&index=0&id=b967ffc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b967ffc4",
  null
  
)

export default component.exports